import { translationService } from './TranslationsService';

export const translate = (key: string): string => {
    return translationService.getTranslation(key);
};

export const initializeTranslations = (): Promise<void> => translationService.loadTranslations();
